import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-create-button',
  standalone: false,
  templateUrl: './create-button.component.html',
})
export class CreateButtonComponent {
  @Input() label: string;
  @Input() tooltip: string;
  @Output() triggered = new EventEmitter<void>();
  
  onClick(): void {
    this.triggered.emit();
  }
}
